import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthRoutes from "./routes/authRoutes";
import GuestRoutes from "./routes/guestRoute";
import OtpVerifyRoutes from "./routes/otpVerifyRoutes";
import InactiveAccountModal from "./components/InactiveAccountModal";

function App() {
  const { txtconnect_ng_user, isVerified } = useSelector((state) => state.user);
  const isInactive = txtconnect_ng_user && String(txtconnect_ng_user.status) === "0";

  return (
    <>
      {txtconnect_ng_user && isVerified ? (
        <AuthRoutes />
      ) : !txtconnect_ng_user ? (
        <GuestRoutes />
      ) : (
        <OtpVerifyRoutes />
      )}

      {isInactive && <InactiveAccountModal />}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
